<app-hero image="hero/hero_faq.png" title="FAQ">
  <span>Toutes les réponses àvos questions, et bien plus encore !</span>
</app-hero>
<div class="container-flex">
  <div class="row align-items-center content-container">
    <div class="col-12 offset-lg-2 col-lg-8 pt-3 row identity-container">
      @for (category of faqBlocks(); track $index; let catIdx = $index) {
        <h1 class="mb-4 mt-5 ms-1"><i class="bi bi-card-checklist"></i> {{ category.label }}</h1>
        @for (block of category.blocks; track $index; let blockIdx = $index) {
          <app-accordion-item [currentsOpen]="currentsOpen()" (onOpen)="setCurrentOpen($event)"
            (onClose)="closeCurrentOpen($event)" [title]="block.question" [id]="'cat'+catIdx+'block'+blockIdx">
            <span [innerHTML]="block.answer"></span>
          </app-accordion-item>
        }
      }
    </div>
  </div>
</div>